<template lang="jade">
  .query-bar
    .query-fields
      el-row
        el-select(v-model="query.dataType", @change="queryChanged", style="width:208px")
          el-option(label="- Search type -", value="")
          el-option(label="Become Regular Teacher", :value="2")
          el-option(label="Teach 1st Class", :value="3")
          el-option(label="Apply Time", :value="1")
        span.separator
        el-date-picker.start-date(v-model="query.startTime", type="date", placeholder="Start Date")
        span.separator to
        el-date-picker.end-date(v-model="query.endTime", type="date", placeholder="End Date")
        span.separator
        el-input(placeholder='ID / Name / Email', v-model='query.account', style="width: 20em", @keyup.native.enter="queryChanged")
        //- el-select(
        //-   size='small',
        //-   v-model='query.name',
        //-   filterable,
        //-   remote,
        //-   clearable,
        //-   default-first-option,
        //-   placeholder='ID/Name/Email',
        //-   :remote-method='onRemoteMethod',
        //-   :loading='loading',
        //-   @change='onChange')
        //-   el-option(v-for='item in options', :key='item.id', :label='setLabel(item)', :value='item.id')
        span.separator
        el-button.search-btn(icon='search', @click="queryChanged") Search

    table.query-status-result(width="100%", style="table-layout: fixed")
      tr(style="height:64px")
        td Status
        td(v-for="(text, key) of statuses")
          a.status(:class="{selected:query.status === key}", href="javascript:;", @click="setStatus(key)", v-text="text")
        td
        td
      tr(style="height:64px")
        td Result
        td(v-for="(text, key) of auditResults[query.status]")
          a.status(:class="{selected:query.result === key}", href="javascript:;", @click="setAuditResult(key)", v-text="text")
        td(v-for="a of getEmptyTdNumber(auditResults[query.status])")

    el-button.reset-btn(@click="resetFilter") Reset Filter
      <svg class="refresh" width="26" height="17" viewBox="0 0 26 17" xmlns="http://www.w3.org/2000/svg"><g fill-rule="evenodd"><path d="M4.461 13.545L8.1 9.822H.823zM17.717 3.965l3.638 3.723H14.08z"/><path d="M17.442 4.352A7.615 7.615 0 0 1 6.937 14.857l1.235-1.236a5.923 5.923 0 0 0 8.033-8.033l1.237-1.236zm-1.834-2A7.615 7.615 0 0 0 4.936 13.024l1.211-1.211a5.923 5.923 0 0 1 8.25-8.25l1.211-1.211z"/></g></svg>
</template>
<style lang="stylus">
  .query-bar
    .el-input .el-input__icon:before
      color: #afafaf
    .el-input__inner
      border: 1px solid #afafaf
    .refresh
      float:left
      margin-right: -9px
      g
        fill: #73ba00
    .reset-btn:hover, .reset-btn:focus
      .refresh g
        fill: white !important
    & > .el-input, & > .el-select, & > .el-date-picker
      margin-botom: 1em
</style>
<style lang="stylus" scoped>
  .separator
    width: 2em
    display: inline-block
    text-align: center
    vertical-align: top
    height: 36px
    line-height: 36px
  .query-fields
    margin: 26px 0
    .el-col
      margin-right: 1em
    .el-row
      margin-bottom: 22px
      &:last-child
        margin-bottom: 0

  .query-status-result
    border-collapse: collapse
    background-color: rgb(250, 250, 250)
    border-top: #e3e3e3
    border-bottom: #e3e3e3
    tr:last-child
      border-top: none
    tr:last-child
      border-bottom: 1px solid #979797
    tr
      border-top: 1px solid #e3e3e3
      border-bottom: 1px solid #e3e3e3
      td:first-child
        color: rgba(0, 0, 0, .5)
        background-color: rgba(0,0,0,.03)
        text-align: center
        width: 5em
    a.status
      outline: none
      text-decoration: none
      display: inline-block
      color: #333
      white-space: nowrap
      text-align: center
      margin: 0
      font-size: 14px
      min-width: 3em
      border-radius: 15px
      height: 30px
      line-height: 30px
      padding: 0 .5em
      margin: 0 1em
      padding: 0 1em
    a.status:hover
      background-color: #eee

    a.status.selected
      color: white
      background-color: rgb(115, 186, 0)

  .reset-btn
    width: 146px
    margin: 18px 0 0 0
    height: 36px
    text-indent: 1em
    position: relative
    svg
      position: absolute
      left 1em
    span
      vertical-align: middle
      margin-left: 7px
  .search-btn
    position: absolute // fix firefox button disposition bug
</style>

<script>
import $axios from 'axios'
import ElSelect from 'element-ui/lib/select'
const Statuses = {
  '': 'All',
  BASIC_INFO: 'Basic info',
  INTERVIEW: 'Interview',
  CERTIFICATE: 'Certification',
  CONTRACT_INFO: 'Contract Info'
}

const AuditResults = {
  '': {
    '': 'All',
    PASS: 'Pass',
    FAIL: 'Fail',
    PENDING: 'Pending',
    START: 'Start',
    REAPPLY: 'Reapply'
  },
  BASIC_INFO: {
    '': 'All',
    PASS: 'Pass',
    FAIL: 'Fail',
    PENDING: 'Pending'
  },
  INTERVIEW: {
    '': 'All',
    PASS: 'Pass',
    FAIL: 'Fail',
    REAPPLY: 'Reapply',
    PENDING: 'Pending',
    START: 'Start'
  },
  CERTIFICATE: {
    '': 'All',
    PASS: 'Pass',
    PENDING: 'Pending'
  },
  CONTRACT_INFO: {
    '': 'All',
    PASS: 'Pass',
    REAPPLY: 'Reapply',
    PENDING: 'Pending',
    START: 'Start'
  }
}

export default {
  components: {
    ElSelect
  },
  data () {
    return {
      statuses: Statuses,
      auditResults: AuditResults,
      query: makeEmptyQuery(),
      loading: false,
      tempValue: '',
      options: []
    }
  },
  methods: {
    setStatus (val) {
      this.query.status = val
      // if there is no corresponding 'result' for selected 'status'
      // set query.result to empty (All)
      if (typeof this.auditResults[this.query.status][this.query.result] === 'undefined') {
        this.query.result = ''
      }
      this.queryChanged()
    },
    setAuditResult (val) {
      this.query.result = val
      this.queryChanged()
    },
    resetFilter () {
      this.query = makeEmptyQuery()
      this.queryChanged()
    },
    queryChanged (e) {
      this.$emit('querychanged', this.query)
    },
    getEmptyTdNumber (a) {
      // total 6 columns'
      return 6 - Object.keys(a).length + 1
    },
    setLabel (item) {
      return `${item.fullName} (${item.email})`
    },
    onChange (val) {
      this.tempValue = val
      this.queryChanged()
    },
    onRemoteMethod (val) {
      let query = val.trim()
      let candidateId = this.query.account
      if (!val || query.length < 3 || (candidateId && candidateId === this.tempValue)) return
      setTimeout(() => {
        this.loading = true
        this.getTeacherData(query)
      }, 500)
    },
    getTeacherData (query) {
      $axios.get('/referralrest/common/teachers', {
        params: {
          accountType: 'NORMAL',
          account: query
        }
      }).then((res) => {
        if (res.data.success) {
          this.loading = false
          let {data} = res.data
          this.options = data
        }
      }).catch((e) => {
        this.loading = false
      })
    }
  }
}

function makeEmptyQuery () {
  return {
    dataType: '',
    startTime: '',
    endTime: '',
    account: '',
    status: '',
    result: ''
  }
}
</script>



// WEBPACK FOOTER //
// query-bar.vue?5558a9c6